import * as actions from '../action-creators/card';

const initialState = {
  contentData: null,
  purchaseInfo: null,
    purchaseInfoSusc:null,
  seriesData: null,
  recomendationsData: null,
  pin: null,
  width: null,
  errorData: false,
  download: null,
  errorDownload: null
};

export default function card(state = initialState, action) {
  switch(action.type) {
    case actions.CONST_SET_CONTENT_DATA:
      return Object.assign({}, state, { contentData: action.contentData } );
    case actions.GET_DOWNLOAD:
      return Object.assign({}, state, { download: action.download } );
    case actions.CONST_SET_PURCHASE_INFO:
      return Object.assign({}, state, { purchaseInfo: action.purchaseInfo } );
      case actions.CONST_SET_PURCHASE_INFO_SUSC:
          return Object.assign({}, state, { purchaseInfoSusc: action.purchaseInfoSusc } );
    case actions.CONST_SET_SERIES: 
      return Object.assign({}, state, { seriesData: action.seriesData});
    case actions.CONST_SET_RECOMENDATIONS_DATA:
      return Object.assign({}, state, { recomendationsData: action.recomendationsData});
    case actions.CONST_SET_PIN:
      localStorage.setItem('aE',action.pin);
      return Object.assign({}, state, { pin: action.pin});
    case actions.SET_WIDTH:
      return Object.assign({}, state, { width: action.width});
    case actions.SET_ERR_FICHA:
      return Object.assign({}, state, { errorData: action.errorData});
    case actions.SET_ERR_DOWNLOAD:
      return Object.assign({}, state, { errorData: action.errorDownload});
    default:
      return state;
  }
}
